export { Checker };

const Checker = {
  throwDataError() {
    throw new Error(`Data is malformed.`);
  },
  checkTypes(data, types = [], varName = undefined) {
    for (const type of types) {
      let isPrimative = typeof type == "string";
      if (isPrimative) {
        if (type === typeof data) return;
        if (type === "null" && data === null) return;
      }

      let isClass = typeof type == "function";
      if (
        isClass &&
        data !== undefined &&
        data !== null &&
        data.constructor == type
      )
        return;
    }

    throw new Error(`Data ${varName} has invalid type.`);
  }
};
